<template>
    <div v-if="files && files.length" class="mt-1 border-top pt-1">
        <div v-if="anexar_mult && ( model == 'lancamento' )">
            <az-input
                sizing="sm"
                class="mb-2"
                type="checkbox-group"
                label="Anexar em todas as parcelas"
                v-model="anexar_todas" />
        </div>
        <viewer :images="lista_arquivos" v-if="true">   
            <draggable v-model="files" @start="drag=true" @end="drag=false; atualizar_ordem()" ghost-class="primary" draggable2=".form-row">
                <div class="form-row" v-for="(file, ifx) in files" :key="ifx">
                    <div class="col col-1 text-center" v-if="!mobile">
                        <figure class="figure mb-0" v-if="!mobile && getIcon(file) == 'file-image'">
                            <img :src="file.blob" class="figure-img img-fluid rounded mb-0" style="max-height: 36px; max-width: 48px;">
                        </figure>
                    </div>
                    <div class="col col-12 col-md-6">
                        <az-input
                            :icon="getIcon(file) == 'file-image' ? '' : ( 'fa fa-' + getIcon(file) )"
                            type="text"
                            placeholder="Nome do Arquivo"
                            v-model="file.name">
                            <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="!file.link">
                                    <span class="input-group-text">
                                        <small>
                                            <i v-if="file.size > 1024 * 1024 * 2">{{ Math.round( ( file.size / 1024 / 1024 ) * 10 ) / 10 }} Mb</i>
                                            <i v-else>{{ Math.round( file.size / 1024 ) }} Kb</i>
                                        </small>
                                    </span>
                                    <button type="button" class="btn btn-outline-danger" @click="remover_file(ifx)">
                                        <i class="fa fa-trash text-danger" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>

                        <az-input
                            v-if="file.link"
                            icon="fa-solid fa-link"
                            type="text"
                            placeholder="Informe o link..."
                            v-model="file.path" />    

                        <span class="text-danger ml-3 mr-3" v-if="file.error">
                            Arquivo/Nome do Arquivo inválido
                            <div class="small text-muted">
                                {{ file.error }}
                            </div>
                        </span>
                    </div>

                    <div class="col col-12 col-md-5">
                        <!-- Tipo de Arquivo -->
                        <az-input
                            v-if="!mobile && $store.state && $store.state.user"
                            type="select"
                            optionsMode="aql"
                            optionsData="id_tipo_arquivo"
                            optionsDisplay="st_descricao"
                            :optionsName="'tipos_arquivo.index.' + model"
                            service="tipo_arquivos.index"
                            :optionsParm="{ fl_ativo: 1, model: model }"
                            placeholder="Selecionar o tipo de arquivo..."
                            v-model="file.id_tipo_arquivo">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary px-1" type="button" title="Replicar o tipo de arquivo" @click="replicar_tipo(file.id_tipo_arquivo)" :disabled="!file.id_tipo_arquivo">
                                        <i class="fas fa-arrows-alt-v"></i>
                                    </button>
                                </div>  
                            </template>
                        </az-input>

                        <div v-else-if="mobile && tipos && tipos.length">
                            <az-input
                                icon="fa-solid fa-file-circle-question fa-fw"
                                type="select"
                                :optionsList="tipos"
                                optionsData="id_tipo_arquivo"
                                optionsDisplay="st_descricao"
                                placeholder="Selecionar o tipo de arquivo..."
                                v-model="file.id_tipo_arquivo">
                                <template v-slot:buttonposb>
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-secondary px-1" type="button" title="Replicar o tipo de arquivo" @click="replicar_tipo(file.id_tipo_arquivo)" :disabled="!file.id_tipo_arquivo">
                                            <i class="fas fa-arrows-alt-v"></i>
                                        </button>
                                    </div>  
                                </template>
                            </az-input>
                        </div>
                    </div>
                </div>
            </draggable>
        </viewer>

        <viewer :images="lista_arquivos" v-if="false">    
            <table class="table table-sm table-hover mb-0 mt-1">
                <tbody>
                    <tr v-if="exibirInfo">
                        <td colspan="5">
                            <i class="fa fa-info-circle fa-fw mr-2" aria-hidden="true"></i>
                            <span>
                                Selecione o(s) arquivo(s) ou cole (CTRL+V) uma imagem da área de
                                transferência.
                            </span>
                        </td>
                    </tr>
                    <draggable v-model="files" @start="drag=true" @end="drag=false;" ghost-class="primary" draggable=".dragitem" tag="tbody">
                        <tr class="dragitem" v-for="(file, ifx) in files" :key="ifx">
                            <td>
                                <i class="fa-solid fa-bars"></i>
                            </td>
                            <td>
                                <figure class="figure mb-0" v-if="!mobile && getIcon(file) == 'file-image'">
                                    <img :src="file.blob" class="figure-img img-fluid rounded mb-0" style="max-height: 36px; max-width: 48px;">
                                </figure>
                            </td>
                            <td>
                                <az-input
                                    :icon="'fa fa-fw fa-' + getIcon(file)"
                                    type="text"
                                    placeholder="Nome do Arquivo"
                                    v-model="file.name" />

                                <az-input
                                    v-if="file.link"
                                    icon="fa-solid fa-link"
                                    type="text"
                                    placeholder="Informe o link..."
                                    v-model="file.path" />    

                                <span class="text-danger ml-3 mr-3" v-if="file.error">
                                    Arquivo/Nome do Arquivo inválido
                                    <div class="small text-muted">
                                        {{ file.error }}
                                    </div>
                                </span>
                            </td>

                            <td>
                                <!-- Tipo de Arquivo -->
                                <az-input
                                    v-if="!mobile && $store.state && $store.state.user"
                                    type="select"
                                    optionsMode="aql"
                                    optionsData="id_tipo_arquivo"
                                    optionsDisplay="st_descricao"
                                    :optionsName="'tipos_arquivo.index.' + model"
                                    service="tipo_arquivos.index"
                                    :optionsParm="{ fl_ativo: 1, model: model }"
                                    placeholder="Selecionar o tipo de arquivo..."
                                    v-model="file.id_tipo_arquivo">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-secondary px-1" type="button" title="Replicar o tipo de arquivo" @click="replicar_tipo(file.id_tipo_arquivo)" :disabled="!file.id_tipo_arquivo">
                                                <i class="fas fa-arrows-alt-v"></i>
                                            </button>
                                        </div>  
                                    </template>
                                </az-input>

                                <div v-else-if="mobile && tipos && tipos.length">
                                    <az-input
                                        icon="fa-solid fa-file-circle-question fa-fw"
                                        type="select"
                                        :optionsList="tipos"
                                        optionsData="id_tipo_arquivo"
                                        optionsDisplay="st_descricao"
                                        placeholder="Selecionar o tipo de arquivo..."
                                        v-model="file.id_tipo_arquivo">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-secondary px-1" type="button" title="Replicar o tipo de arquivo" @click="replicar_tipo(file.id_tipo_arquivo)" :disabled="!file.id_tipo_arquivo">
                                                    <i class="fas fa-arrows-alt-v"></i>
                                                </button>
                                            </div>  
                                        </template>
                                    </az-input>
                                </div>
                            </td>

                            <td>
                                <a href="#" @click.prevent="remover_file(ifx)">
                                    <i class="fa fa-trash text-danger" aria-hidden="true"></i>
                                </a>

                                <span class="ml-3" v-if="!file.link">
                                    <i v-if="file.size > 1024 * 1024 * 2">{{ Math.round( ( file.size / 1024 / 1024 ) * 10 ) / 10 }} Mb</i>
                                    <i v-else>{{ Math.round( file.size / 1024 ) }} Kb</i>
                                </span>
                            </td>
                        </tr>
                    </draggable>
                </tbody>

            </table> 

            <!--
            <ul class="list-group mt-2 list-group-flush" v-if="false">
                <li class="list-group-item list-group-item-info mb-1" v-if="exibirInfo">
                    <i class="fa fa-info-circle fa-fw mr-2" aria-hidden="true"></i>
                    <span>
                        Selecione o(s) arquivo(s) ou cole (CTRL+V) uma imagem da área de
                        transferência.
                    </span>
                </li>

                <li class="list-group-item list-group-item-danger mb-1" v-if="false && tamanho_total > limite">
                    <i class="fa fa-exclamation-triangle fa-fw mr-2" aria-hidden="true"></i>
                    <span>
                        Tamanho máximo de upload (10Mb) excedido: {{ Math.round(tamanho_total / 1024 / 1024) }} MB
                    </span>
                </li>

                <li class="list-group-item list-group-item-light justify-content-between p-1" :class="mobile ? '' : 'd-flex'" v-for="(file, ifx) in files" :key="file.id">
                    <div :class="mobile ? '' : 'd-flex'">
                        <figure class="figure">
                            <img :src="file.blob" class="figure-img img-fluid rounded mr-2" style="max-height: 32px; max-width: 32px;">
                        </figure>
                        
                        <az-input
                            :icon="'fa fa-fw fa-' + getIcon(file)"
                            type="text"
                            placeholder="Nome do Arquivo"
                            v-model="file.name" />

                        <az-input
                            class="ml-3"
                            v-if="file.link"
                            icon="fa-solid fa-link"
                            type="text"
                            placeholder="Informe o link..."
                            v-model="file.path" />

                        <az-input
                            v-if="!mobile && $store.state && $store.state.user"
                            type="select"
                            optionsMode="aql"
                            optionsData="id_tipo_arquivo"
                            optionsDisplay="st_descricao"
                            :optionsName="'tipos_arquivo.index.' + model"
                            service="tipo_arquivos.index"
                            :optionsParm="{ fl_ativo: 1, model: model }"
                            placeholder="Selecionar o tipo de arquivo..."
                            v-model="file.id_tipo_arquivo"
                            class="ml-3">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary px-1" type="button" title="Replicar o tipo de arquivo" @click="replicar_tipo(file.id_tipo_arquivo)" :disabled="!file.id_tipo_arquivo">
                                        <i class="fas fa-arrows-alt-v"></i>
                                    </button>
                                </div>  
                            </template>
                        </az-input>

                        <div v-else-if="mobile && tipos && tipos.length">
                            <az-input
                                icon="fa-solid fa-file-circle-question fa-fw"
                                type="select"
                                :optionsList="tipos"
                                optionsData="id_tipo_arquivo"
                                optionsDisplay="st_descricao"
                                placeholder="Selecionar o tipo de arquivo..."
                                v-model="file.id_tipo_arquivo">
                                <template v-slot:buttonposb>
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-secondary px-1" type="button" title="Replicar o tipo de arquivo" @click="replicar_tipo(file.id_tipo_arquivo)" :disabled="!file.id_tipo_arquivo">
                                            <i class="fas fa-arrows-alt-v"></i>
                                        </button>
                                    </div>  
                                </template>
                            </az-input>
                        </div>

                        <a class= "ml-3 mt-2" href="#" @click.prevent="remover_file(ifx)">
                            <i class="fa fa-trash text-danger" aria-hidden="true"></i>
                        </a>

                        <span class="ml-3 mt-2" v-if="!file.link">
                            <i v-if="file.size > 1024 * 1024 * 2">{{ Math.round( ( file.size / 1024 / 1024 ) * 10 ) / 10 }} Mb</i>
                            <i v-else>{{ Math.round( file.size / 1024 ) }} Kb</i>
                        </span>

                        <span class="text-danger ml-3 mt-2 mr-3" v-if="file.error">
                            Arquivo/Nome do Arquivo inválido
                            <div class="small text-muted">
                                {{ file.error }}
                            </div>
                        </span>
                    </div>
                    <div v-if="model == 'marcacao' && false">
                        <div class="input-group mb-0">
                        <div class="input-group-prepend">
                            <button class="btn btn-outline-secondary" type="button" id="button-addon1" @click="file.tipo_ = !file.nopep; $forceUpdate();"
                            title="Exibir no Prontuário Eletrônico.">
                            <i class="fa fa-eye-slash" aria-hidden="true" v-if="file.nopep"></i>
                            <i class="fa fa-eye" aria-hidden="true" v-else></i>
                            </button>
                        </div>
                        <label class="form form-control">PEP</label>
                        </div>
                    </div>
                </li>
            </ul>
            -->
        </viewer>

        <div class="text-right">
            <button type="button" class="btn btn-sm btn-outline-primary" @click="baixarSelecionados" title="Download de arquivos.">
                <i class="fa-solid fa-file-arrow-down"></i>
            </button>
        </div>
    </div>
</template>

<script>
import AzInput from "../shared/forms/AzInput.vue";
import draggable from "vuedraggable";

export default {
  data: function() {
    return {
        drag: false, 
        anexar_todas: true, 
    };
  },
  props: ["files", "exibirInfo", "model", "mobile", "tipos", "anexar_mult"],
  components: { 
    AzInput,
    draggable 
  },
  computed: { 
    tamanho_total: function() {
      return this.files.reduce((total, file) => total + (file.size || 0), 0);
    },
    limite: function() {
      return 1024 * 1024 * 10;
    },
    lista_arquivos: function () { 
        if ( !this.files || !this.files.length ) { 
            return [];
        }

        return this.files.map((file) => { 
            return file.blob;
        });
    }
  },
  methods: {

    // Download dos arquivos...

    baixarArquivo(file) {
        if ( !file.file ) { 
            return;
        }

        const url = URL.createObjectURL(file.file);

        const a = document.createElement('a');
        a.href = url;
        a.download = file.file.name || 'arquivo';
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    },

    baixarSelecionados() {
        this.files.forEach((file, index) => {
            setTimeout(() => {
                this.baixarArquivo(file);
            }, index * 300);
        });

        this.$toast.add({
            severity: 'success',
            summary: 'Download iniciado',
            detail: 'Os arquivos selecionados estão sendo baixados.',
            life: 3000
        });
    },

    //

    atualizar_ordem () { 
        this.files.forEach( (file, index) => { 
            file.ordem = index + 1;
        });
    },

    replicar_tipo(id_tipo_arquivo) {
      this.files.forEach((file) => {
        if (file.id_tipo_arquivo !== id_tipo_arquivo) {
          file.id_tipo_arquivo = id_tipo_arquivo;
        }
      });
    },
    remover_file (index) { 
        this.files.splice(index, 1);
    },

    getIcon(file) {
      if ( file.link ) { 
        return 'file-code'; 
      }

      if (!/\.(jpeg|jpe|jpg|gif|png)$/i.test(file.name)) {
        return "file-pdf";
      }

      return "file-image";
    }
  }
};
</script>

<style></style>
